// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"33def9e4","592":"c21f6301"}[chunkId] + ".chunk.css";
};